import cloneDeep from 'lodash/cloneDeep';

import get from 'lodash/get';
import findIndex from 'lodash/findIndex';

import {
  FETCH_FLAXY_TESTS_IN_BUILD_SUCCESS,
  LAMBDATEST_DELETE_TEST_LOCAL,
  LAMBDATEST_INFINITE_TEST_DATA_CLEAR,
  LAMBDATEST_INFINITE_TEST_DATA_FAILED,
  LAMBDATEST_INFINITE_TEST_DATA_LOADING,
  LAMBDATEST_INFINITE_TEST_DATA_SILENT_LOADING,
  LAMBDATEST_INFINITE_TEST_DATA_SUCCESS,
  LAMBDATEST_SSE_TEST_LIST_DATA_UPDATE,
  LAMBDATEST_TEST_DATA_ADD,
  LAMBDATEST_TEST_DATA_CLEAR,
  LAMBDATEST_TEST_DATA_FAILED,
  LAMBDATEST_TEST_DATA_FETCH_MORE_FAILED,
  LAMBDATEST_TEST_DATA_FETCH_MORE_LOADING,
  LAMBDATEST_TEST_DATA_FETCH_MORE_SUCCESS,
  LAMBDATEST_TEST_DATA_LOADING,
  LAMBDATEST_TEST_DATA_LOADING_MORE,
  LAMBDATEST_TEST_DATA_REMOVE,
  LAMBDATEST_TEST_DATA_SUCCESS,
  LAMBDATEST_TEST_DATA_UPDATE,
  LAMBDATEST_TEST_DATA_UPDATE_SSE_EVENT,
  LAMBDATEST_TEST_SEARCH_CLEAR,
  LAMBDATEST_TEST_SEARCH_FAILED,
  LAMBDATEST_TEST_SEARCH_LOADING,
  LAMBDATEST_TEST_SEARCH_SUCCESS,
  LAMBDATEST_UPDATE_TESTDATA,
  LAMBDATEST_UPDATE_TESTNAME_CLEAR,
  LAMBDATEST_WITHOUT_BUILD_FAILURE,
  LAMBDATEST_WITHOUT_BUILD_LOADING,
  LAMBDATEST_WITHOUT_BUILD_SUCCESS,
  SET_SHOULD_FILTER_UNIQUE_TESTS,
  UPDATE_TEST_MUTE_STATUS_SIDEBAR_LIST,
} from '../actionTypeConstants/LambdaTestTestDataConstants';

import { deleteObjectById } from '../../utils/utilityFunctions';
import { testApiCalllimit } from '../actions/lambdaTestTestDataActions';

const initialState = {
  testData: {
    loading: false,
    data: null,
    error: null,
    total: null,
    loadingMore: false,
    loadingMoreError: null,
    silentLoading: false,
  },
  infiniteTestData: {
    loading: false,
    data: null,
    error: null,
    total: null,
    loadingMore: false,
    loadingMoreError: null,
    silentLoading: false,
  },
  flakyTestsInSelectedBuild: [],
  totalFlakyTestsInBuild: 0,
  areSearchResultsLoaded: false,
  areSearchResultsLoading: false,
  searchResults: [],
  shouldFilterUniqueTests: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LAMBDATEST_TEST_DATA_LOADING: {
      return {
        ...state,
        testData: {
          ...state.testData,
          loading: true,
          silentLoading: false,
        },
      };
    }

    case LAMBDATEST_TEST_DATA_LOADING_MORE: {
      return {
        ...state,
        testData: {
          ...state.testData,
          loading: false,
          silentLoading: false,
        },
      };
    }

    case LAMBDATEST_TEST_DATA_SUCCESS: {
      const testDataArray = state.testData.data
        ? [...state.testData.data, ...action.result.data.tests]
        : action.result.data.tests;
      const { isSharingRoute = false, isNewUi = false } = action.payload;
      let hasMore = action.result.data.tests.length === testApiCalllimit;
      if (isSharingRoute && !isNewUi) {
        hasMore = action.result.data.total > testDataArray.length;
      }
      return {
        ...state,
        testData: {
          ...state.testData,
          loading: false,
          silentLoading: false,
          total: action.result.data.total,
          data: testDataArray,
          hasMore: hasMore,
          error: null,
          isAutoHealedBuild: action.result.data?.autoHeal,
        },
      };
    }

    case LAMBDATEST_SSE_TEST_LIST_DATA_UPDATE: {
      const existingTestData = state.testData.data || [];
      const {
        tests: sseUpdatedTestData,
        isNewCypressTestView,
      } = action.payload;

      const updatedTestList = existingTestData.map((test) => {
        if (sseUpdatedTestData[test.id]) {
          const _test = { ...test, ...sseUpdatedTestData[test.id] };
          delete sseUpdatedTestData[test.id];
          return _test;
        }
        return test;
      });

      let newUpdatedTestList = [];

      // to add spec group if not present in the existing test data
      if (isNewCypressTestView) {
        newUpdatedTestList = [...updatedTestList];
        Object.values(sseUpdatedTestData).forEach((test) => {
          let isCypressGroupPresent = false;
          newUpdatedTestList.forEach((item) => {
            if (item.name === test.name) {
              isCypressGroupPresent = true;
            }
          });

          if (!isCypressGroupPresent) {
            isCypressGroupPresent = true;

            // adding empty groupTestsInfo to identify cypress spec group
            newUpdatedTestList.push({ ...test, groupTestsInfo: {} });
          }
        });
      } else {
        newUpdatedTestList = [
          ...(Object.values(sseUpdatedTestData) || []),
          ...updatedTestList,
        ];
      }

      return {
        ...state,
        testData: {
          ...state.testData,
          loading: false,
          silentLoading: false,
          data: newUpdatedTestList,
        },
      };
    }

    case LAMBDATEST_TEST_DATA_ADD: {
      const newTestData = action.payload;
      const newData = state.testData.data
        ? [newTestData, ...state.testData.data]
        : null;
      return {
        ...state,
        testData: {
          ...state.testData,
          loading: false,
          silentLoading: false,
          data: newData,
        },
      };
    }

    case LAMBDATEST_TEST_DATA_UPDATE: {
      const updatedTestData = action.payload;
      const tests = state.testData.data || [];
      const testToUpdateIndex = tests.findIndex(
        ({ id }) => id === updatedTestData.id
      );
      if (testToUpdateIndex > -1) {
        const testToUpdate = tests[testToUpdateIndex];
        const prevStatus = testToUpdate['status'];
        const prevStatusInd = testToUpdate['statusInd'];
        const prevTestName = testToUpdate['name'];
        const newTestName = get(
          updatedTestData,
          ['name'],
          testToUpdate['name']
        );

        // If the status has not changed, do nothing.
        if (
          prevStatus === updatedTestData.status &&
          prevStatusInd === updatedTestData.statusInd &&
          prevTestName === newTestName
        ) {
          return state;
        }
        const startedAt = updatedTestData.startedAt
          ? updatedTestData.startedAt
          : testToUpdate.startedAt
          ? testToUpdate.startedAt
          : '';
        testToUpdate['status'] = updatedTestData.status;
        testToUpdate['statusInd'] = updatedTestData.statusInd;
        testToUpdate['startedAt'] = startedAt;
        testToUpdate['endedAt'] = get(updatedTestData, ['endedAt'], '');
        testToUpdate['name'] = newTestName;
        return {
          ...state,
          testData: {
            ...state.testData,
            loading: false,
            data: tests,
          },
        };
      }
      return state;
    }

    case LAMBDATEST_TEST_DATA_REMOVE: {
      const updatedTestData = action.payload;
      const tests = cloneDeep(state.testData.data);
      if (tests) {
        const testToRemoveIndex = tests.findIndex(
          ({ id }) => id === updatedTestData.id
        );
        if (testToRemoveIndex > -1) {
          tests.splice(testToRemoveIndex, 1);
        }
      }
      return {
        ...state,
        testData: {
          ...state.testData,
          loading: false,
          data: tests,
        },
      };
    }

    case LAMBDATEST_TEST_SEARCH_SUCCESS: {
      return {
        ...state,
        areSearchResultsLoading: false,
        areSearchResultsLoaded: true,
        searchResults: get(action, ['result', 'data', 'tests'], []),
      };
    }

    case LAMBDATEST_TEST_SEARCH_LOADING: {
      return {
        ...state,
        areSearchResultsLoading: true,
      };
    }

    case LAMBDATEST_TEST_SEARCH_FAILED: {
      return {
        ...state,
        areSearchResultsLoading: false,
        areSearchResultsLoaded: true,
        searchResults: [],
      };
    }

    case LAMBDATEST_TEST_SEARCH_CLEAR: {
      return {
        ...state,
        areSearchResultsLoading: false,
        searchResults: [],
      };
    }

    case LAMBDATEST_TEST_DATA_FAILED: {
      if (action.error.message === 'api request cancelled') {
        return {
          ...state,
          testData: {
            ...state.testData,
            loading: true, // loading true since a new api will be called post the cancellation
            silentLoading: false,
            error: !action.error.message ? null : action.error, // Since cancelled api calls also end up here with error message as undefined
          },
        };
      }
      return {
        ...state,
        testData: {
          ...state.testData,
          loading: false,
          silentLoading: false,
          error: !action.error.message ? null : action.error,
        },
      };
    }

    case LAMBDATEST_TEST_DATA_CLEAR: {
      return {
        ...state,
        testData: initialState.testData,
      };
    }

    case LAMBDATEST_INFINITE_TEST_DATA_LOADING: {
      return {
        ...state,
        infiniteTestData: {
          ...state.infiniteTestData,
          loading: true,
          silentLoading: false,
        },
      };
    }

    case LAMBDATEST_INFINITE_TEST_DATA_SILENT_LOADING: {
      return {
        ...state,
        infiniteTestData: {
          ...state.infiniteTestData,
          loading: false,
          silentLoading: true,
        },
      };
    }

    case LAMBDATEST_INFINITE_TEST_DATA_SUCCESS: {
      return {
        ...state,
        testData: {
          ...state.infiniteTestData,
          loading: false,
          silentLoading: false,
          total: action.result.data.total,
          data: action.result.data.tests,
        },
      };
    }

    case LAMBDATEST_INFINITE_TEST_DATA_FAILED: {
      return {
        ...state,
        infiniteTestData: {
          ...state.infiniteTestData,
          loading: false,
          silentLoading: false,
          error: action.error,
        },
      };
    }

    case LAMBDATEST_INFINITE_TEST_DATA_CLEAR: {
      return {
        ...state,
        infiniteTestData: initialState.infiniteTestData,
      };
    }

    case LAMBDATEST_TEST_DATA_FETCH_MORE_LOADING: {
      return {
        ...state,
        testData: {
          ...state.testData,
          loadingMore: true,
        },
      };
    }

    case LAMBDATEST_TEST_DATA_FETCH_MORE_SUCCESS: {
      return {
        ...state,
        testData: {
          ...state.testData,
          loadingMore: false,
          data: [...state.testData.data, ...action.result.data.tests],
        },
      };
    }

    case LAMBDATEST_TEST_DATA_FETCH_MORE_FAILED: {
      return {
        ...state,
        testData: {
          ...state.testData,
          loadingMoreError: action.error,
          loadingMore: false,
        },
      };
    }

    case LAMBDATEST_WITHOUT_BUILD_LOADING: {
      return {
        ...state,
        testData: {
          ...state.testData,
          loading: false,
          error: action.error,
        },
      };
    }

    case LAMBDATEST_WITHOUT_BUILD_SUCCESS: {
      return {
        ...state,
        testData: {
          ...state.testData,
          loading: false,
          data: action.result.data.tests,
          total: action.result.data.total,
        },
      };
    }

    case LAMBDATEST_WITHOUT_BUILD_FAILURE: {
      return {
        ...state,
        testData: {
          ...state.testData,
          loadingMoreError: action.error,
          loadingMore: false,
        },
      };
    }

    case LAMBDATEST_TEST_DATA_UPDATE_SSE_EVENT: {
      const testDataArray = state.testData.data;
      let currentSelectedBuildIds =
        action.payload.lambdaFilterObject &&
        action.payload.lambdaFilterObject.build;
      let index = findIndex(testDataArray, { id: action.payload.test.id });
      if (testDataArray && testDataArray.length) {
        if (index > -1) {
          let testData = action.payload.test;
          if (action.payload.test.type === 'cypress') {
            let caps;
            try {
              caps = JSON.parse(action.payload.test.capability);
            } catch (error) {
              caps = {};
            }
            testData = {
              ...action.payload.test,
              path: caps.path,
            };
          }
          testDataArray.splice(index, 1, testData);
        } else {
          if (currentSelectedBuildIds && currentSelectedBuildIds.length > 0) {
            if (
              currentSelectedBuildIds.includes(
                action.payload.test.buildId.toString()
              )
            ) {
              testDataArray.splice(0, 0, action.payload.test);
            }
          } else {
            testDataArray.splice(0, 0, action.payload.test);
          }
        }
        return {
          ...state,
          testData: {
            ...state.testData,
            loading: false,
            silentLoading: false,
            data: testDataArray,
            total: testDataArray.length,
          },
        };
      } else {
        return state;
      }
    }

    case LAMBDATEST_UPDATE_TESTDATA: {
      const testData = state.testData.data;
      const { testName = '', testId = '', status = '' } = action?.payload || {};
      if (testData) {
        const foundIndex = testData.findIndex((test) => test.id == testId);
        testData[foundIndex].name = testName;
        if (status) {
          testData[foundIndex].status = status;
        }
      }
      return {
        ...state,
        testData: {
          ...state.testData,
          data: testData,
          updatetestName: {
            data: action?.payload,
          },
        },
      };
    }

    case LAMBDATEST_UPDATE_TESTNAME_CLEAR: {
      return {
        ...state,
        testData: {
          ...state.testData,
          updatetestName: {
            data: {},
          },
        },
      };
    }

    case FETCH_FLAXY_TESTS_IN_BUILD_SUCCESS: {
      const payload = action.result;
      const flakyTestList = get(payload, ['data', 'data', 'flaky_tests'], []);
      const totalFlakyTests = get(payload, ['data', 'data', 'total'], []);
      return {
        ...state,
        flakyTestsInSelectedBuild: flakyTestList,
        totalFlakyTestsInBuild: totalFlakyTests,
      };
    }

    case SET_SHOULD_FILTER_UNIQUE_TESTS: {
      const shouldFilterUniqueTests = action.payload;
      return {
        ...state,
        shouldFilterUniqueTests,
      };
    }

    case LAMBDATEST_DELETE_TEST_LOCAL: {
      // testParam can be either testId or testName based on the view
      const { testParam, isNewCypressTestView } = action.payload;

      return {
        ...state,
        testData: {
          ...state.testData,
          data: isNewCypressTestView
            ? deleteObjectById(state.testData.data, 'name', testParam)
            : deleteObjectById(state.testData.data, 'id', testParam),
        },
      };
    }

    case UPDATE_TEST_MUTE_STATUS_SIDEBAR_LIST: {
      const { testId = "", isMuted = "" } = action?.payload || {};
      const testData = state.testData.data;
      if (testData) {
        const foundIndex = testData.findIndex(test => test.id == testId);
        if (foundIndex !== -1) {
          testData[foundIndex].featureFlag.isMuted = isMuted;
        }
      }
      return {
        ...state,
        testData: {
          ...state.testData,
        }
      };
    }

    default:
      return state;
  }
}
